import { matchPath } from "react-router-dom";
import { routes } from "config/routes";

const COMPETITIVE_ANALYSIS_PATH_PATTERN = `${routes.private.assetDashboard}/competitors`;

export const getLayoutContentMaxWidth = (pathname: string) => {
  if (pathname === routes.private.properties) return "auto";

  return matchPath(COMPETITIVE_ANALYSIS_PATH_PATTERN, pathname)
    ? "none"
    : "1700px";
};
